import React from 'react';
import Icon from '../../../components/openplay/OpenPlayIcon';

const MetricsCard = ({ title, value, icon, trend, trendDirection, variant = 'default' }) => {
  const getVariantStyles = () => {
    switch (variant) {
      case 'warning':
        return 'bg-warning/10 border-warning/20';
      case 'info':
        return 'bg-accent/10 border-accent/20';
      default:
        return 'bg-card border-border';
    }
  };

  const getIconColor = () => {
    switch (variant) {
      case 'warning':
        return 'text-warning';
      case 'info':
        return 'text-accent';
      default:
        return 'text-primary';
    }
  };

  return (
    <div className={`rounded-xl border p-4 shadow-elevation-1 transition-smooth hover:shadow-elevation-2 ${getVariantStyles()}`}>
      <div className="flex items-start justify-between mb-3">
        <div className={`flex items-center justify-center w-10 h-10 rounded-lg bg-primary/10 ${getIconColor()}`}>
          <Icon name={icon} size={20} />
        </div>
        {trend && (
          <span
            className={`text-xs font-medium px-2 py-1 rounded-full ${
              trendDirection === 'up'
                ? 'bg-success/10 text-success'
                : 'bg-destructive/10 text-destructive'
            }`}
          >
            {trendDirection === 'up' ? '↑' : '↓'} {trend}
          </span>
        )}
      </div>
      <div>
        <p className="text-2xl font-bold text-foreground">{value}</p>
        <p className="text-xs text-muted-foreground mt-1 caption">{title}</p>
      </div>
    </div>
  );
};

export default MetricsCard;
